export const INDUSTRIES = [
  {
    slug: "contractors", name: "Contractors & builders",
    sub: "General contractors, and the electrical, plumbing, HVAC, roofing, and concrete trades working under them.",
    rows: [
      ["Usually needed", "General liability, workers' compensation, commercial auto, tools and equipment, and builder's risk on active jobs."],
      ["Where deals get stuck", "Certificate wording. General contractors want additional insured on a blanket basis, primary and non-contributory, with a waiver of subrogation. If your policy can't produce it, you don't get on site."],
      ["Watch out for", "Uninsured subcontractors. If a sub has no coverage and someone gets hurt, your policy pays and your audit bill treats their payroll as yours. Collect certificates before they start."],
      ["Turnaround", "Send us the insurance section of the contract and we'll tell you same day whether your current policy meets it."],
    ],
  },
  {
    slug: "restaurants", name: "Restaurants & bars",
    sub: "Full service, quick service, food trucks, and bars — including liquor liability.",
    rows: [
      ["Usually needed", "Business owner's policy, workers' compensation, liquor liability if you serve alcohol, and equipment breakdown."],
      ["Where claims come from", "Kitchen fires, walk-in cooler failures that spoil inventory, slip-and-falls in the dining room, and burns and cuts on the line."],
      ["Watch out for", "Food spoilage is often a small sublimit that doesn't cover a full walk-in. Check the number before the compressor fails, not after."],
      ["Also relevant", "If you serve alcohol, dram shop exposure in Texas is real and general liability excludes it. Liquor liability is a separate coverage."],
    ],
  },
  {
    slug: "medical-dental", name: "Medical, dental & clinics",
    sub: "Private practices, dental groups, outpatient clinics, and imaging centers.",
    rows: [
      ["Usually needed", "Professional liability (malpractice), general liability, workers' compensation, cyber with HIPAA coverage, and equipment coverage."],
      ["Where claims come from", "Treatment allegations, and increasingly, protected health information exposed through email or a vendor."],
      ["Watch out for", "Claims-made malpractice policies. If you switch carriers or retire without tail coverage, past patients can still bring claims against nothing. Ask about tail before you move."],
      ["Also relevant", "HIPAA breach notification costs alone can run past six figures for a mid-sized patient list. Cyber limits should reflect record count."],
    ],
  },
  {
    slug: "property-managers", name: "Property managers & landlords",
    sub: "Multifamily, single-family portfolios, and the management companies running them.",
    rows: [
      ["Usually needed", "Commercial property, general liability, loss of rents, and an umbrella. Management companies also need errors and omissions."],
      ["Where claims come from", "Tenant injuries in common areas and stairwells, water damage moving between units, and storm losses to roofs and fences."],
      ["Watch out for", "Vacancy clauses. Most policies restrict coverage once a unit sits empty past a set number of days — tell us before a turnover drags on."],
      ["Also relevant", "Loss of rents keeps cash flow going while a building is being repaired. It's inexpensive and routinely underinsured."],
    ],
  },
  {
    slug: "hotels", name: "Hotels & hospitality",
    sub: "Independent hotels, extended stay, and event venues.",
    rows: [
      ["Usually needed", "Commercial property, general liability at high limits, liquor liability, workers' compensation, and business income."],
      ["Where claims come from", "Guest injuries around pools, stairs, and elevators; storm damage to the building; and food service exposure."],
      ["Watch out for", "Business income limits set on last year's occupancy. If revenue moved, the limit needs to move with it."],
      ["Also relevant", "Franchise agreements usually dictate minimum limits and specific additional insured wording. Send us the agreement."],
    ],
  },
  {
    slug: "landscaping", name: "Landscaping & lawn care",
    sub: "Maintenance crews, design-build, irrigation, and tree work.",
    rows: [
      ["Usually needed", "General liability, commercial auto for trucks and trailers, inland marine for mowers and equipment, and workers' compensation."],
      ["Where claims come from", "Equipment theft from trailers, rocks thrown by mowers into windows and cars, and vehicle accidents with crews on board."],
      ["Watch out for", "Tree removal and anything involving climbing or chainsaws is rated differently and excluded on some policies. Tell us if you do it."],
      ["Also relevant", "Chemical application needs a specific endorsement for herbicide drift onto neighboring property."],
    ],
  },
];

export const industryBySlug = (slug) => INDUSTRIES.find((i) => i.slug === slug);
